import { BadgeTypes } from 'dash-ui';

import { PropertyStatusesEnum } from 'dash-common';

export const BADGE_TO_STATUS_COLOR_MAP: Record<
  PropertyStatusesEnum,
  BadgeTypes
> = {
  [PropertyStatusesEnum.PRIVATE]: 'alert',
  [PropertyStatusesEnum.PUBLIC]: 'active',
  [PropertyStatusesEnum.DRAFT]: 'neutral',
  [PropertyStatusesEnum.ARCHIVED]: 'inactive',
  [PropertyStatusesEnum.SOLD_OUT]: 'warning',
};
